import { render, staticRenderFns } from "./ReturnPendingReport.vue?vue&type=template&id=ff0b1e4a&"
import script from "./ReturnPendingReport.vue?vue&type=script&lang=js&"
export * from "./ReturnPendingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports